<div class="container-fluid" [ngClass]="{'d-none': !showPageInfo}">
  <div class="row">
    <div class="col-12">
      <ng-container
        *ngIf="formBuilderInfo && (!dashboardInfo || (dashboardInfo && dashboardInfo.dashboardType !== 'preDefTemplate')); else dashboardTemplate">
        <div class="row">
          <div class="col-12"
            [ngClass]="{'simple-form-padding': ['simple_form', 'form_builder_dashboard'].includes(pageFormType) }">
            <div
              [ngClass]="{'simple-form-container': ['simple_form', 'form_builder_dashboard'].includes(pageFormType) }">
              <div class="row" *ngIf="showPageTitleSection && !isMultiStepForm">
                <div class="col-12 px-0 fb-page-bg">
                  <app-fb-page-title-parent-action-button [pageFormType]="pageFormType"
                    [formBuilderInfo]="formBuilderInfo" [showSimpleForm]="showSimpleForm"
                    (pageFormButtonClicked)="onPageFormButtonClicked($event)"></app-fb-page-title-parent-action-button>
                </div>
              </div>
              <div class="row" *ngIf="showSimpleForm && (simpleFormButton || formDataId)">
                <div class="col-12 px-0">
                  <app-fb-simple-form [simpleFormButton]="simpleFormButton" [pageFormType]="pageFormType"
                    [formTypeSelected]="formTypeSelected" [isFBModulePreview]="isFBModulePreview"
                    [formBuilderInfo]="formBuilderInfo" (backToMasterList)="onBackToMasterList()"
                    [dataFormId]="formDataId"></app-fb-simple-form>
                </div>
              </div>

              <div class="row" *ngIf="pageFormType === 'master_listing_table' && !showSimpleForm && !isMultiStepForm">
                <div class="col-12 px-0">
                  <app-master-list-table [formBuilderId]="formBuilderId" [formBuilderInfo]="formBuilderInfo"
                    (actionTriggered)="handleAction($event)"></app-master-list-table>
                </div>
              </div>
              <div *ngIf="pageFormType === 'vertical_tab_navigation'">
                <app-fb-vertical-tab [formBuilderInfo]="formBuilderInfo"></app-fb-vertical-tab>
              </div>
              <div *ngIf="isMultiStepForm
              && pageFormType !== 'vertical_tab_navigation' && pageFormType !== 'horizontal_tab_navigation'">
                <app-fb-multi-step-form [steps]="steps" [onBackToMasterList]="onBackToMasterListReference"
                  [simpleFormButton]="simpleFormButton" [btnClick]="buttonClicked"
                  [dataFormId]="formDataId"></app-fb-multi-step-form>
              </div>
              <div *ngIf="pageFormType === 'horizontal_tab_navigation'">
                <app-fb-horizontal-tab [formBuilderInfo]="formBuilderInfo"></app-fb-horizontal-tab>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #dashboardTemplate>
        <ng-container *ngIf="formBuilderInfo && dashboardInfo?.dashboardType === 'preDefTemplate'; else noMappedForm">
          <app-fb-dashboard [dashboardTemplate]="dashboardInfo?.dashboardTemplate"
            [titleToRedirectPageFormId]="dashboardInfo?.titleToRedirectPageFormId"
            [notificationRedirectPageFormId]="dashboardInfo?.notificationTypeRedirectPageFormId"></app-fb-dashboard>
        </ng-container>
      </ng-template>
      <ng-template #noMappedForm>
        <div class="row">
          <div class="col-12">
            <span class="no-mapped-form">No form mapped to the above selected menu.</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
